module.exports = __webpack_public_path__ + "img/AFMS_KEY_OFF.390892d6.png";